<div class="align-components search-box">
    <i (click)="onSearchIconClick()" class="fa fa-search fa-2x" title="Global Search (Ctrl+M)" style="display: none;"></i>
    <div *ngIf="showSearchPopup">
        <nalco-global-search></nalco-global-search>
    </div>
</div>
<div class="overlay" *ngIf="showSearchPopup" (click)="onclick()"></div>